import { jsx as _jsx } from "react/jsx-runtime";
import { BATTLESHIP, SLINKY } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../utils/isFlow';
import styled from 'styled-components';
const Container = styled.div.withConfig({
  displayName: "Separator__Container",
  componentId: "sc-1kq23mv-0"
})(["display:flex;width:100%;justify-content:center;align-items:center;text-align:center;color:", ";margin:", "px auto;&::before,&::after{content:'';border-top:1px solid ", ";margin:0 15px 0 0;flex:1 0 20px;}&::after{margin:0 0 0 15px;}"], BATTLESHIP, isFlow(Flow.Integrations) ? 22 : 32, BATTLESHIP);
const Or = styled.span.withConfig({
  displayName: "Separator__Or",
  componentId: "sc-1kq23mv-1"
})(["color:", ";"], SLINKY);

const Separator = ({
  message
}) => {
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Or, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    })
  });
};

export default Separator;